/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     NAME: seo.ts
   AUTHOR: Harikrishnan Gangadharan
 COMMENTS: 

/***************************************************************************************************************************
 DEFINITIONS
****************************************************************************************************************************/
const SEOMetadata: Record<string, string> = {
  siteName: 'TECH INFRA - Steel Detailing',
  siteUrl: 'https://www.tec-infra.com',
  siteLogo: '/assets/images/logo.png',
  siteLogoWidth: '512',
  siteLogoHeight: '512',
  email: 'sales@tec-infra.com',
  description:
    "Crafting steel structures with precision and passion. Your blueprint to excellence starts here with our expert steel detailing services. Let's build your vision, one detail at a time."
};

export default SEOMetadata;
